var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-simples",style:(_vm.tamanho ? ("width: " + _vm.tamanho + "px; height: " + _vm.tamanho + "px;") : '')},[_c('div',{class:['circulo', (_vm.classe + "-simples")]}),_c('div',{staticClass:"circulo-sombra"})])}
var staticRenderFns = []

export { render, staticRenderFns }